/**
 * Ensemble de fonctions utilitaires
 * @module services
 */

export * from './services/colors'
export * from './services/centroid'
export * from './services/geojsons'
export * from './services/intersects'
export * from './services/projections'
export * from './services/styles'
export * from './services/styles-literal.js'
export * from './services/transforms'
export * from './services/geom'
export { FeatureUnion } from './services/featureUnion'
export { FeatureSplit } from './services/featureSplit'
export { Calc } from './services/calc'
